import PropTypes from 'prop-types';
import { FormState } from 'common/entities/form/FormTypes';

import { useFormState } from 'utils/hooks';
import { config } from './config';

const Fields = ({ formState, label, onRemove, showHeader, isEditDisabled }) => {
  const { fields, changeField, selectField } = useFormState(formState);
  const renderComponent = config[label === 'date_joined' ? 'date_joined' : 'default'];

  return renderComponent({
    selectField,
    changeField,
    onRemove,
    fields,
    showHeader,
    isEditDisabled
  });
};

export default Fields;

Fields.propTypes = {
  formState: FormState,
  label: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
  showHeader: PropTypes.bool,
  isEditDisabled: PropTypes.bool
};
